/*
* This regex checks that a string optionally starts with one or more 0 - 9 characters,
* optionally includes a decimal
* and optionally ends with one or more 0 - 9 characters.
*/
export const ROW_TREE_SPACING_REGEX = new RegExp(/^([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/);

export const REQUIRED_SPACING_CROP_FAMILY_IDS = [4, 5, 6, 7];

export const DB_SCOUTROUTETAG_COUNT = 'COUNT';
export const DB_SCOUTROUTETAG_SIZE = 'SIZE';
export const DB_SCOUTROUTETAG_BOX = 'BOX';
export const DB_SCOUTROUTETAG_TREE = 'FULLTREE';
export const DB_SCOUTROUTETYPE_YIELD = 'Yield';

export enum DbScoutMissionType {
  Problem = 1,
  Yield = 2
}

export enum TreeGroupType {
  Normal = 1,
  Irrigation = 2
}

export const DB_MARKER_DISEASE_KEY = 'diseases';
export const DB_MARKER_PEST_KEY = 'pests';
export const DB_MARKER_WEEDS_KEY = 'weeds';
export const DB_MARKER_YIELD_KEY = 'yield_samples';
export const DB_MARKER_IRRIGATION_KEY = 'irrigation_samples';
export const DB_MARKER_NO_PROBLEM_KEY = 'is_no_problem';
export const DB_MARKER_OTHER_KEY = 'other_samples';
export const DB_MARKER_DRONE_KEY = 'drone_samples';

export const DATAWINDOW_SATELLITE_CHART = 'satelliteChart';
export const DATAWINDOW_MYROUTES = 'myRoutes';

// The same key is used for map pin icons and sidebar item
export const MARKER_ICONS = {
  [DB_MARKER_PEST_KEY]: 'pest',
  [DB_MARKER_DISEASE_KEY]: 'disease',
  [DB_MARKER_WEEDS_KEY]: 'weed',
  [DB_MARKER_IRRIGATION_KEY]: 'irrigation',
  [DB_MARKER_NO_PROBLEM_KEY]: 'noproblem',
  [DB_MARKER_OTHER_KEY]: 'other',
  [DB_MARKER_DRONE_KEY]: 'drone'
};

export enum GUIDE_WIZARD {
  GROUP_TREES,
  SCOUT_ROUTE,
  EDIT_SCOUT_ROUTE,
  ADD_MISSING_TREES,
  GROUP_MISSING_TREES_FOR_DELETION,
  GROUP_TREES_FOR_DELETION
}

export const DB_FALSE_CODLING_MOTH_PEST_TYPE_ID = 48;

export const CLIENT_ROLE_TYPE_MAPPINGS = {
  owner: 1,
  admin: 2,
  farm_group_owner: 3,
  farmer: 4,
  farm_manager: 5,
  scout: 6,
  consultant: 7,
  authorized_reseller: 8,
  agent: 9
};

export const GROUP_TREE_LOCALSTORAGE_KEY = 'TreeGroups';
export const CITRUS_CROP_FAMILY_ID = 3;

export const LOCAL_NOTIFICATIONS_LOCALSTORAGE_KEY = 'aeroLocalNotifications';
export const HOLLSTEIN_SOME_CLOUD_COVER = 0.05;
export const HOLLSTEIN_SIGNIFICANT_CLOUD_COVER = 0.1;

export const TABLE_GRAPES_ID = 7;
export const CROP_TYPE_SYMBOLIC_TYPE_BLOCK = 'Blocks';

export const CI_MAP_LAYER_NAME = 'ci';
export const CI_MAP_LAYER_ID = 18;
export const CI_SYMBOLIC_LAYER_ID = 19;

export const BLUE_BASE = '#0075E1';
export const NAVY_BASE = '#17293E';
export const AQUA_BASE = '#5DD39E';
export const PEACH_BASE = '#FA7657';

export const SILVER_BASE_LIGHTEN40 = '#F6F6F6';

export const NEW_PLATFORM_URL = 'https://app.aerobotics.com/grower';

export const CROP_INSURANCE_PRODUCT_ID = 8;